import styled from 'styled-components';

import Text from 'components/_core/Text';

export {
  Body,
  CloseButton,
  DetailsHeader,
  Header,
  Properties,
  Property,
  PropertyLabel,
  PropertyValue,
  Title,
} from '../../styles';

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ActionsHeader = styled(Text).attrs({ variant: 'light' })`
  display: flex;
  flex-direction: column;
  padding-left: ${({ theme }) => theme.spacings.abs8}px;
  padding-right: ${({ theme }) => theme.spacings.abs8}px;
`;
